import { IconName, getIconSVG } from "../../../../gui/IconSVG.js";
import { PARTHENOPE_GLOBAL_CSS_PREFIX } from "../../ParthenopeGUIV2.js";

export interface ModalContainer {
    modal: Modal,
    modalContent: HTMLElement
}
 
export class Modal {
    private readonly bClass = `${PARTHENOPE_GLOBAL_CSS_PREFIX}`;
    
    private html: HTMLElement;
    private closeBtn: HTMLElement;
    private label?: string;
    private content?: HTMLElement;
    private opened: boolean = false;

    get isOpen(): boolean {
        return this.opened;
    }

    constructor(private container?: HTMLElement) {}

    public updateContainer(container: HTMLElement) {
        this.container = container;
    }

    private initHTML() {
        this.closeBtn = <div class={`${this.bClass}-modal__box-close`}>
            {getIconSVG(IconName.close)}
        </div>;

        this.closeBtn.addEventListener('click', () => { this.close() })

        this.html = <div class={`${this.bClass}-modal`}>
            <div class={`${this.bClass}-modal__box`}>
                <div class={`${this.bClass}-modal__box-label`}>
                    {this.label}
                    {this.closeBtn}
                </div>
                {this.content}
            </div>
        </div>
    }
    
    public toggle(label: string, content: HTMLElement) {
        if(this.opened) {
            this.close();
        } else {
            this.open(label, content);
        }
    }

    public open(label: string, content: HTMLElement) {
        this.updateContent(true, label, content);
    }

    public close() {
        this.updateContent(false);
    }

    private updateContent(opened: boolean, label?: string, content?: any) {
        this.label = label;
        this.content = content;
        
        if(label && content) {
            this.initHTML()
            this.container.appendChild(this.html)            
        } else {
            this.container.removeChild(this.html);
        }

        this.setOpenStatus(opened);
    }

    private setOpenStatus(status: boolean): void { 
        this.html.classList.toggle(`${this.bClass}-modal--opened`);
        this.opened = status;
    }
    
}